"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const keautils_1 = require("keautils");
function filtrarFiltroOrden(x, columnKeys) {
    return Object.assign({}, x, { columna: keautils_1.filterObject(x.columna, (x, key) => keautils_1.contains(columnKeys, key)), orden: x.orden && (keautils_1.contains(columnKeys, x.orden.columna) ? x.orden : undefined) });
}
function filtrarDrillDowns(x, columnKeys) {
    return keautils_1.filterObject(x, (x, key) => keautils_1.contains(columnKeys, x.columna));
}
function filterMapping(x, columnkeys, drilldownKeys) {
    return keautils_1.intersect(x, [...columnkeys, ...drilldownKeys]);
}
/**Obtiene los valores por default del grid state y filtra los nombres de las columnas que no existe, esto es por que como el grid state generalmente se almacena en los cookies, puede ser
 * que nuevas versiones del sistema ya no tengan columnas que esten referenciadas en el mismo
 */
function gridStateDefaultValues(value, originalColumnKeys) {
    value = value || {};
    const drilldownKeys = Object.keys(value.drillDowns || {});
    return {
        filtroOrden: value.filtroOrden ? filtrarFiltroOrden(value.filtroOrden, originalColumnKeys) : { busqueda: "", columna: {}, orden: undefined },
        drillDowns: value.drillDowns ? filtrarDrillDowns(value.drillDowns, originalColumnKeys) : {},
        paginacion: value.paginacion || { selectedPage: 0, selectedPageSize: 15 },
        mapping: value.mapping ? filterMapping(value.mapping, originalColumnKeys, drilldownKeys) : originalColumnKeys,
        export: value.export ? filterMapping(value.export, originalColumnKeys, drilldownKeys) : originalColumnKeys
    };
}
exports.gridStateDefaultValues = gridStateDefaultValues;



//////////////////
// WEBPACK FOOTER
// ./~/kea-react/dist/grid2Base/simpleGrid/gridState.js
// module id = 2235
// module chunks = 0